import { SVGProps, Ref, forwardRef } from 'react';

export const CopyFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M0 5.832C0 1.167.667.5 5.332.5c3.708 0 4.89.421 5.219 2.936-1.13.003-2.12.045-2.948.201-.87.164-1.696.477-2.345 1.126s-.961 1.475-1.125 2.344c-.161.856-.201 1.884-.201 3.061q0 .503.011.968C.53 10.97 0 9.988 0 5.832"
                fill="currentColor"
            />
            <path
                d="M10.664 4.836c-4.666 0-5.332.667-5.332 5.332 0 4.666.666 5.332 5.332 5.332s5.332-.666 5.332-5.332-.667-5.332-5.332-5.332"
                fill="currentColor"
            />
        </g>
    </svg>
));
CopyFilledSize16Glyph.displayName = 'CopyFilledSize16Glyph';
